var CrossDomainPolicy = (function () {
    function CrossDomainPolicy() {
    }
    return CrossDomainPolicy;
}());
export { CrossDomainPolicy };
CrossDomainPolicy.ANONYMOUS = 'anonymous';
CrossDomainPolicy.USE_CREDENTIALS = 'use-credentials';



// WEBPACK FOOTER //
// ../dist/lib/net/CrossDomainPolicy.js